<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#0074FF">
        <path
          d="M14.5 15c.276 0 .5.224.5.5 0 .245-.177.45-.41.492L14.5 16H.5c-.276 0-.5-.224-.5-.5 0-.245.177-.45.41-.492L.5 15h14zm-7-15c.245 0 .45.177.492.41L8 .5v9.793l4.146-4.147c.174-.173.443-.192.638-.057l.07.057c.173.174.192.443.057.638l-.057.07-5 5-.013.011c-.012.012-.025.023-.039.033l.052-.044c-.027.026-.056.05-.087.069l-.035.02-.041.02-.04.014c-.015.005-.03.009-.046.012l-.033.006-.051.005H7.48l-.052-.005L7.5 12c-.036 0-.071-.004-.105-.011l-.046-.012-.04-.015c-.014-.005-.027-.012-.04-.019-.013-.006-.025-.013-.036-.02l-.017-.012-.018-.013c-.014-.01-.027-.02-.04-.033l-.012-.011-5-5c-.195-.196-.195-.512 0-.708.174-.173.443-.192.638-.057l.07.057L7 10.293V.5c0-.276.224-.5.5-.5z"
          transform="translate(1)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'DownloadIcon',
  props: {
    height: VueTypes.string.def('16'),
    width: VueTypes.string.def('16'),
  },
};
</script>

<style lang="scss"></style>
